import React, { useState, useEffect } from "react";
import "../Orders/Orders.css";
import "../Inventory/Inventory.css";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

function createData1(invoiceNo, date, customer, contact, amount, payment) {
  return {
    invoiceNo,
    date,
    customer,
    contact,
    amount,
    payment,
  };
}

const rows1 = [
  createData1(
    "INV-2025-014",
    "13-Sep-2025, 4:15 PM",
    "Ramesh",
    "98765 43210",
    "₹2,450",
    "UPI"
  ),
  createData1(
    "INV-2025-014",
    "13-Sep-2025, 4:15 PM",
    "Ramesh",
    "98765 43210",
    "₹2,450",
    "UPI"
  ),
  createData1(
    "INV-2025-014",
    "13-Sep-2025, 4:15 PM",
    "Ramesh",
    "98765 43210",
    "₹2,450",
    "UPI"
  ),
  createData1(
    "INV-2025-014",
    "13-Sep-2025, 4:15 PM",
    "Ramesh",
    "98765 43210",
    "₹2,450",
    "UPI"
  ),
];

export const SubViewAllSales = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [salesCardData, setSalesCardData] = useState({});
  async function LoadSalesCardData() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/dashboard/subdistributor/sales-card/"
      );
      if (response.data.status === "success" || response.status === 200) {
        setSalesCardData(response.data?.data);
        console.log("Sales card data fetched succesfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch sales card data"
      );
      console.log("Failed to fetch sales card data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    LoadSalesCardData();
  }, []);
  // pos
  const [pospage, setPosPage] = useState(0);
  const [posrowsPerPage, setPosRowsPerPage] = useState(5);
  const [postotalCount, setPosTotalCount] = useState(0);

  const handleChangePosRowsPerPage = (event) => {
    setPosRowsPerPage(+event.target.value);
    setPosPage(0); // reset to first page
  };
  // Filters
  const [searchText, setSearchText] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [filterToggler, setFilterToggler] = useState("");
  const [categoryToggler, setCategoryToggler] = useState("");

  const [posInvoiceData, setPosInvoiceData] = useState({});
  async function fetchPosInvoiceDetails() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: pospage + 1, // atleast 1 page
          page_size: posrowsPerPage,
          search: searchText,
          payment_mode: paymentMode,
          category: categoryToggler,
        },
      };

      const response = await axiosInstance.get(
        "/invoice/subdistributor/pos-sales-invoice/",
        config
      );
      if (response.data.status === "Success" || response.status === 200) {
        setPosInvoiceData(response.data.data);
        setPosTotalCount(response.data?.data.count);
        console.log("Pos details fetched successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch pos details");
      console.log("Failed to fetch pos details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchPosInvoiceDetails();
  }, [pospage, posrowsPerPage, searchText, paymentMode, categoryToggler]);

  // CLEAR FILTERS
  function handleClearFilters() {
    setFilterToggler("");
    setPaymentMode("");
    setSearchText("");
    setCategoryToggler("");
  }

  // RESET
  function handleReset() {
    setSearchText("");
  }
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown"
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div className="dasboardTitle">
              <div>
                <span>
                  <Link
                    to="/sub-dashboard"
                    style={{ color: "black", marginRight: "5px" }}
                  >
                    <FaArrowLeftLong />
                  </Link>
                </span>
                Sales History
              </div>
              <div>View and manage all POS sales transactions.</div>
            </div>
            <div className="d-flex gap-2">
              <div>{""}</div>
              <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/sub-sales")}>New Sale</button>
              </div>
            </div>
          </div>

          {/* cards section  */}
          <div className="OrdersCardsGrid mt-4">
            <div className="inventoryCard">
              <div>Total Sales This Month</div>
              <div>₹ {salesCardData?.this_month_sales ?? "---"}</div>
            </div>
            <div className="inventoryCard">
              <div>Today’s Sales</div>
              <div> ₹ {salesCardData?.todays_sales ?? "---"}</div>
            </div>
            <div className="inventoryCard">
              <div>Cash Sales Today</div>
              <div>₹ {salesCardData?.cash_sales_today ?? "---"}</div>
            </div>
            <div className="inventoryCard">
              <div>UPI Sales Today</div>
              <div>₹ {salesCardData?.upi_sales_today ?? "---"} </div>
            </div>
          </div>
          {/* <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div>
                <input type="text" placeholder="Search" />
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    All
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Payment Mode</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    All
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="addButtonContainer">{""}</div>
          </div> */}

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Payment Mode</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("");
                        setPaymentMode("");
                      }}
                    >
                      All
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("Cash");
                        setPaymentMode("cash");
                      }}
                    >
                      Cash
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("UPI");
                        setPaymentMode("upi");
                      }}
                    >
                      UPI
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Payment Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setCategoryToggler("All")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggler(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          {(searchText || paymentMode || categoryToggler) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchText}
                  </>
                )}

                {paymentMode && (
                  <>
                    {" "}
                    , <strong>Payment Mode:</strong> {paymentMode}
                  </>
                )}

                {categoryToggler && (
                  <>
                    {" "}
                    , <strong>Category:</strong> {categoryToggler}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          {/* table  */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Invoice No.</TableCell>
                    <TableCell align="left">Date & Time</TableCell>
                    <TableCell align="left">Customer Name</TableCell>
                    <TableCell align="left">Contact</TableCell>
                    <TableCell align="left">Amount</TableCell>
                    <TableCell align="left">Payment Mode</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {posInvoiceData?.results?.length > 0 ? (
                    posInvoiceData?.results?.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell component="th" scope="row">
                          {row.invoice_number ?? "--"}
                        </TableCell>
                        <TableCell align="left">
                          {row.due_date ?? "--"}
                        </TableCell>
                        <TableCell align="left">
                          {row.customer_name ?? "--"}
                        </TableCell>
                        <TableCell align="left">{row.contact}</TableCell>
                        <TableCell align="left">{row.total ?? "---"}</TableCell>
                        <TableCell align="left">
                          {row.payment_mode ?? "---"}
                        </TableCell>

                        <TableCell align="left">
                          <button
                            className="btnTableView"
                            onClick={() => {
                              navigate("/sub-invoice-view", {
                                state: { Id: row.id },
                              });
                            }}
                          >
                            View
                          </button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={postotalCount}
              page={pospage}
              onPageChange={(event, newPage) => setPosRowsPerPage(newPage)}
              rowsPerPage={posrowsPerPage}
              onRowsPerPageChange={handleChangePosRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>
        </div>
      </div>
    </>
  );
};
